import { h, Component } from "preact";
import Modal from "./Modal";
import TicketMapping from "./TicketMapping";

export default class TicketMappingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false
    };
  }

  componentWillMount() {
    this.updateDimensions();
    const isBrowser = typeof window !== "undefined";
    if (isBrowser) {
      window.removeEventListener("resize", this.updateDimensions);
    }
  }

  updateDimensions = () => {
    const isBrowser = typeof window !== "undefined";
    const isMobile = !isBrowser || !window || window.innerWidth <= 600;
    this.setState({ isMobile: isMobile });
  };

  render() {
    const { showModal, onClose } = this.props;
    const { isMobile } = this.state;
    if (showModal) {
      return (
        <Modal
          padding={isMobile ? 0 : 20}
          closeMargin={isMobile ? "20px 20px 0px 0px" : 0}
          showModal={showModal}
          closeHandler={onClose}
          destroy={false}
        >
          <TicketMapping />
        </Modal>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./components/TicketMappingModal.js